module.exports = __webpack_public_path__ + "img/portal5.1c1cb121.png";